import React from 'react';
import { Truck, Award, Tag, CalendarDays } from 'lucide-react';

const features = [
  {
    icon: Truck,
    title: 'Free Local Delivery',
    desc: 'Complimentary delivery within 10km of our Campsie store. Conditions apply.',
  },
  {
    icon: Tag,
    title: 'Factory Outlet Prices',
    desc: 'Direct-from-factory pricing on every piece in store.',
  },
  {
    icon: Award,
    title: 'Quality Guarantee',
    desc: 'Premium materials and craftsmanship built to last.',
  },
  {
    icon: CalendarDays,
    title: 'Open 7 Days',
    desc: 'Drop in any day of the week. Just give us a quick call before you come.',
  },
];

const WhyChooseUs = () => {
  return (
    <section className="py-20 md:py-24 px-6 md:px-10 bg-[#f7f5f1]">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <p className="text-xs md:text-sm text-gray-500 mb-3 tracking-[0.3em] uppercase">
            The Satis Promise
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-medium text-black tracking-tight font-display-serif">
            Why shop with us
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.map((f, idx) => {
            const Icon = f.icon;
            return (
              <div
                key={idx}
                className="bg-white rounded-2xl p-7 md:p-8 text-center border border-black/5 hover:border-black/20 transition-colors duration-300"
              >
                <div className="w-14 h-14 mx-auto mb-5 rounded-full bg-black flex items-center justify-center">
                  <Icon className="w-6 h-6 text-white" strokeWidth={1.5} />
                </div>
                <h3 className="text-lg md:text-xl font-semibold text-black mb-2">
                  {f.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {f.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
